<template>
  <div>
    <div class="tax-information hour-salary">
      <div class="tax-head">
        <h1>Salaries</h1>
      </div>

      <div class="navbar-holder">
        <ul class="inner-navbar">
          <li class="li-width">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Month</label>
              <div class="">
                <select
                class="form-select form-control"
                id="selMonth"
                name="selMonth"
                v-model="selectedMonth"
                @change="onChange(selectedMonth)"
            >
            <option v-for="(month, index) in months" :key="index" :value="index + 1" :disabled="index >= nextMonth">
              {{ month }}
            </option>
            </select>
              </div>
            </div>
          </li>
          <li class="li-width">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Year</label>
              <div class="">
                <select v-model="selectedYear" id="selYear" name="selYear" class="form-select form-control" @change="onYearChange(selectedYear)">
                  <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>
            </div>
          </li>
          <li>
            <input type="text" class="form-control" placeholder="Search by Employee Name" v-model="search" @keyup="searchByName" />
          </li>
          <li>
            <button class="btn btn-primary" @click="newSaveEmployeesSalaries()"
              >Save All </button>
          </li>
        </ul>
      </div>
      <div class="table-scroll salary-calculation">
        <table class="table" id="tblData" style="position: relative">
           <span class="spinnerCustom">
                     <clip-loader :loading="loadingSpinMain" :size="sizeMain" :color="spinnerColor"></clip-loader>
                </span>
          <thead class="table-head">
            <tr>
              <th scope="col"></th>
              <th scope="col">Employee</th>
              <th scope="col">Basic Salary</th>
              <th scope="col">Current Month Salary</th>
              <th scope="col">Allowances/Bonuses</th>
              <th scope="col">Deductions</th>
              <th scope="col">Tax</th>
              <th scope="col">NET PAYABLE</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="loadingSpin">
              <clip-loader
                :loading="loadingSpin"
                :size="size"
                :color="spinnerColor"
              ></clip-loader>
            </tr>
            <tr v-show="NotFound">
              <td class="text-center">No Employee Found</td>
          </tr>
            <tr v-for="employeesSalary in employeesSalaries" :key="employeesSalary.id">
              <td>
              </td>
              <td class="text-capitalize" @click="setUserData(employeesSalary.employee)">
                <router-link :to="{ path: '/employee/profile/' + employeesSalary.employee.uuid + '' }">
                  {{ employeesSalary.employee.name }}
                </router-link>
              </td>
              <td>{{currencyFormatter2(employeesSalary.basic_salary)}}</td>
              <td>{{currencyFormatter2(employeesSalary.current_month_salary)}}</td>
              <td>{{currencyFormatter2(employeesSalary.allowances)}}</td>
              <td>{{currencyFormatter2(employeesSalary.deductions)}}</td>
              <td>{{currencyFormatter2(employeesSalary.tax)}}</td>
              <td >{{ currencyFormatter2(employeesSalary.balance) }}</td>
            </tr>
           <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{currencyFormatter2(totalAllowance)}}</td>
              <td>{{currencyFormatter2(totalDeduction)}}</td>
              <td>{{currencyFormatter2(totalTax)}}</td>
              <td>Total &nbsp;&nbsp;=&nbsp;&nbsp;&nbsp; <strong>{{ currencyFormatter2(sumAllAmount) }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="navbar-holder text-right" v-if="lockShowHide">
            <a v-on:click="ExportXLSX()" class="btn btn-info" v-if="sumAllAmount>0">Generate CSV</a>
        <a v-on:click="lockAndSendEmail()" class="btn btn-warning"
        ><clip-loader :loading="loading" :size="size" :color="spinnerColor"></clip-loader>
          Lock & Send Email</a>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import collect from "collect.js";
export default {
  name: "salary-calculator",

  components: {
    DatePicker,ClipLoader
  },

  data() {
    return {
      selectedMonth: new Date().getMonth() + 1,
      sizeMain: '35px',
      loadingSpinMain: false,
      size: '25px',
      spinnerColor: '#00779C',
      loading: false,
      loadingSaveBtn: false,
      calculationType:"with",
      totalBasicSalary:0,
      sumCurrentEmpSalary:0,
      totalCurrentEmpSalary:0,
      totalAllowance:0,
      totalDeduction:0,
      totalTax:0,
      val: 0,
      date: "",
      company_id: this.$store.getters.getSelectedCompany.id,
      range: "",
      employees: [],
      sumAllAmount: 0,
      empAllow: [],
      empCurrentSalary: [],
      empDect: [],
      empTax: [],
      empNetPay: [],
      popid: 0,
      pop_name: "",
      deduction: 0,
      index: 0,
      taxAmount: [],
      netAmount: 0,
      company_benefit: [],
      rows: [],
      arrayofAllownces: [
        {
          type: "",
          description: "",
          amount: "",
        },
      ],
      defaultAllownce: [
        {
          type: "",
          description: "",
          amount: "",
        },
      ],
      form: {
        company_id: this.$store.getters.getSelectedCompany.id,
        basic_salary: 0,
        from_date: null,
        to_date: null,
        employee_id: [],
        allownces: 0,
        deductions: 0,
        tax: 0,
        netAmount: 0,
        sumAllAmount: 0,
        employee_allow: [],
      },
      lock: {
        from_date: null,
        to_date: null,
        employee_id: [],
      },
      lock1: null,
      is_lock: null,
      bonus: 0,
      bonuses: 0,
      tax: 0,
      salaries: [],
      user: [],
      dataArray: [],
      bonusArray: [],
      is_data: false,
      indexEmp: 0,
      delflag: false,
      empID: 0,
      is_calculate: 0,
      tableRowsCount: 2,
      tableRows: [1],
      singleEmployee: [],
      employeeBenefitArray: [],
      filteredEmpoyee: [],
      employees2: [],
      alwnceAmount: 0,
      deductAmount: 0,
      moreBenefits: [],
      moreDeduction: [],
      bonusAndDeductionArray: [],
      bonusDeductionLoop: [],
      sumOfBonusDeduction: [],
      seperateAllowances: [],
      allMoreBenefitsDeductions: [],
      lockShowHide:true,
      invalidCalc:'',
      employeesSalaries: [],
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      search: '',
      NotFound: false,
      employeesSalaries2: [],
      loadingSpin: false,
      selectedYear: new Date().getFullYear(), // Default to current year
      numPreviousYears: 10, // Number of previous years to include in the dropdown
    };
  },
  serverPrefetch() {},
  mounted() {
    this.getSalaries();
  },
  computed: {
    nextMonth() {
      const currentMonth = new Date().getMonth();
      return (currentMonth + 1) % 12; // Get index of next month, wrapping around to January if current month is December
    },
    availableYears() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - this.numPreviousYears;
      const endYear = currentYear;
      return Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
    }
  },
  methods: {
    lockAndSendEmail(){
      if(confirm('Are you sure that you want to lock this salary?')){
        if(this.sumAllAmount !== 0) {
          if (this.is_lock !== 0) {
            this.loading = true;
            var data = {
              company_id: this.company_id,
              selectedMonth: this.selectedMonth,
              selectedYear: this.selectedYear,
            };
            this.$axios({
              method: "POST",
              data: data,
              url: this.$CalculatedSalaryLock,
              headers: this.getAuthHeader(),
            }).then((res) => {
              if (res.data.status == 200) {
                this.loading = false;
                $root.$toast.success('Salary saved successfully!');
              }
            });
          } else {
            $root.$toast.success("This salary locked already!");
          }
        }
      }
    },
    setUserData(user){
      this.$store.commit('setEmployeeProfileId', user);
    },

    onChange() {
      this.getSalaries();
    },

    onYearChange() {
      this.getSalaries();
    },

    getSalaries()
    {
      this.loadingSpin = true;
      let params = {
        company_id: this.company_id,
        selectedMonth: this.selectedMonth,
        selectedYear: this.selectedYear,
      };
      this.$axios
        .get(this.$getEmployeesSalaries, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.employeesSalaries = response.data.result;
          this.loadingSpin = false;
          this.employeesSalaries2 = this.employeesSalaries;
          if (this.employeesSalaries.length > 0) {
            this.employeesSalaries.forEach((element) => {
              this.totalBasicSalary += element.basic_salary;
              this.totalAllowance += parseFloat(element.allowances);
              this.totalDeduction += parseFloat(element.deductions);
              this.totalTax += parseFloat(element.tax);
              this.sumAllAmount += parseFloat(element.balance);
            });
          } else {
            this.totalBasicSalary = 0;
            this.totalAllowance = 0;
            this.totalDeduction = 0;
            this.totalTax = 0;
            this.sumAllAmount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    saveEmployeesSalaries()
    {
      this.loadingSpin = true;
      let params = {
        company_id: this.company_id,
        selectedMonth: this.selectedMonth,
      };
      this.$axios
        .get(this.$saveEmployeesSalaries, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.loadingSpin = false;
            $root.$toast.success(response.data.message);
            this.totalBasicSalary = 0;
            this.totalAllowance = 0;
            this.totalDeduction = 0;
            this.totalTax = 0;
            this.sumAllAmount = 0;
            this.getSalaries();
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },

    newSaveEmployeesSalaries()
    {
      this.loadingSpin = true;
      let params = {
        company_id: this.company_id,
        selectedMonth: this.selectedMonth,
        selectedYear: this.selectedYear,
      };
      this.$axios
        .get(this.$newSaveEmployeesSalaries, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.loadingSpin = false;
            $root.$toast.success(response.data.message);
            this.totalBasicSalary = 0;
            this.totalAllowance = 0;
            this.totalDeduction = 0;
            this.totalTax = 0;
            this.sumAllAmount = 0;
            this.getSalaries();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    ExportXLSX() {
      //Export in Excel
      // if (this.val != 0) {
        this.isHidden = true;
        var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
        var textRange;
        var j = 0;
        var tab = document.getElementById("tblData"); // id of table

        for (j = 0; j < tab.rows.length; j++) {
          var row = tab.rows[j];
          var numberOfCells = row.cells.length;
          // row.deleteCell(numberOfCells - 1);
          tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
        }

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
          // If Internet Explorer
          txtArea1.document.open("txt/html", "replace");
          txtArea1.document.write(tab_text);
          txtArea1.document.close();
          txtArea1.focus();
          sa = txtArea1.document.execCommand("SaveAs", true, "Thanks.xls");
        } else {
          let a = $("<a />", {
            href:
              "data:application/vnd.ms-excel," + encodeURIComponent(tab_text),
            download: "SalaryCalculations.xls",
          })
            .appendTo("body")
            .get(0)
            .click();
        }
    },

    currencyFormatter2(value){
     return this.currencyFormatter(value);
    },

    searchByName()
    {
        this.employeesSalaries = this.employeesSalaries2;
        collect().macro("whereLike", function (search) {
            var searched = new RegExp(search, "i");
            return this.filter((item) =>
                searched.test(item.employee.name)
            );
        });
        if (this.search !== '') {
            const searchRegex = new RegExp(this.search.trim(), "i");
                    this.employeesSalaries = this.employeesSalaries2.filter(employeesSalary => searchRegex.test(employeesSalary.employee.name));
                    if (this.employeesSalaries.length === 0) {
                        this.NotFound = true; // Set NotFound to true when no employees are found
                    } else {
                        this.NotFound = false;
                    }
                } else {
                    this.NotFound = false;
        }
    }
},
};
</script>
<style>

.hour-salary tbody tr td.p-0 {
  padding: 0 !important;
}
.li-width {
  width: 150px !important;
}
.spinnerCustom .v-spinner {
  position: absolute;
  margin: 0 auto;
  width: 100%;
  z-index: 1111111;
  top: 50%;
}
</style>
